module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "i": "footer_wrap"
    }
  }, [_c('div', {
    staticClass: "footer"
  }, [_c('span', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        return _vm.goto()
      }
    }
  }, [_vm._v("粤ICP备18043405号")]), _vm._v("  Copyright © 2006-2020 大艺博官网")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b216342!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 1017
// module chunks = 59